<template>
  <main class="document-page">
    <TopBar :page-header="$t('sidebar.documents')" />
    <div class="content">
      <div class="document-container">
        <div :class="`container ${allowedExtensions && allowedExtensions.length === 0 ?'withborder':''}`">
          <template v-if="!documents || documents.length === 0">
            {{ $t("documentPage.noDocuments") }}
          </template>
          <template v-else>
            <rowResp :gutter="12">
              <columnResp v-for="document in documents"
                          :key="document.Id"
                          :xs="12"
                          :md="6"
                          :lg="6"
                          :xl="6"
              >
                <div class="documentcard"
                     @click="downloadFile(document)"
                >
                  <div v-if="['jpg','jpeg','gif','png','bmp'].indexOf(document.Extension) > -1">
                    <span class="material-icons big-icons">image</span>
                  </div>
                  <div v-else-if="['pdf','docx','doc','txt'].indexOf(document.Extension) > -1">
                    <span class="material-icons big-icons">description</span>
                  </div>
                  <div v-else>
                    <span class="material-icons big-icons">question_mark</span>
                  </div>
                  {{ document.Name }}
                </div>
              </columnResp>
            </rowresp>
          </template>
        </div>
      </div>

      <div v-if="allowedExtensions && allowedExtensions.length > 0"
           class="button-container"
      >
        <div class="container">
          <button type="submit"
                  class="btn"
                  @click="SelectFilesForUpload"
          >
            {{ $t("documentPage.uploadFile") }}
          </button>
          <br>
          <input v-show="false"
                 id="file1"
                 type="file"
                 multiple="multiple"
                 @change="onChange"
          >
          <div class="progress-wrapper">
            <div id="progress-bar-file1"
                 class="progress"
            />
          </div>
        </div>
      </div>
    </div>
  </main>
</template>

<script setup>
import TopBar from "../components/TopBar.vue";
import { computed, onMounted } from 'vue'
import {API_PostDocument} from '../apiCalls/api.js'
import { useToast } from "vue-toastification";
import { useStore } from "vuex";
import i18n from '../locales/i18n'
  
const toast = useToast();
const store = useStore();

const documents = computed(() => store.state.documents.documents)
const allowedExtensions = computed(() => store.state.documents.allowedExtensions)


onMounted(async () => {
  store.dispatch('documents/getAllowedFileExtensions');
  store.dispatch('documents/getDocuments');
});


function SelectFilesForUpload(){
  var input = document.getElementById('file1');
  input.click();

}


async function downloadFile(documentInfo){
  try{
    const byteCharacters = window.atob(documentInfo.Base64);
    const byteNumbers = new Array(byteCharacters.length);
    for (let i = 0; i < byteCharacters.length; i++) {
        byteNumbers[i] = byteCharacters.charCodeAt(i);
    }
    const byteArray = new Uint8Array(byteNumbers);
    const blob = new Blob([byteArray], { type: 'application/' + documentInfo.Extension })
    const link = document.createElement('a')
    link.href = URL.createObjectURL(blob)
    link.download = documentInfo.Name+"."+ documentInfo.Extension;
    link.click()
    URL.revokeObjectURL(link.href)
  }
  catch(e){
    toast.error( i18n.global.t('documentPage.DownloadFailed') +"\r\n\r\n"+ e.message )
  }
  
}


async function onChange(){
  var input = document.getElementById('file1');
  

  //for (const file of input.files) {
  //  const postResponse = await API_PostDocument(chosenCustomer.value.Id, file);
  //  console.log(postResponse)
  //}

  var formdata = new FormData();

  var allFilesAllowed = true;
  for(const file of input.files){
    const fileParts = file.name.split('.')
    const fileExtension = fileParts[fileParts.length-1];
    if(allowedExtensions.value.indexOf(fileExtension) == -1){
      allFilesAllowed = false;
      break;
    }
  }

  if(!allFilesAllowed){
    toast.info(i18n.global.t('documentPage.FileTypesNotAllowed')+allowedExtensions.value.join(', '));
    return;
  }

  for (const file of input.files) {
    formdata.append('file', file);
  }
  try{
    // eslint-disable-next-line
    const postResponse = await API_PostDocument(formdata);
    store.dispatch('documents/getDocuments');
    toast.success(i18n.global.t('documentPage.UploadSuccess'))
  }catch (e) {
    toast.warning(e.message);
  }
  
}
</script>


<style lang="scss" scoped>

@import "../scss/buttons.scss";
.document-page {
  height: 100vh;
  overflow-y: scroll;
  font-family: Avenir, Helvetica, Arial, sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  text-align: center;
  background: linear-gradient(90deg, var(--gray) 0%, var(--background2) 10px);
  width:100%;
  .content {
    height: calc(100% - 90px);
    padding: 2rem;
  }
}

@media(max-width:768px) {
      .document-page .content{
        padding-top: 6rem;
        min-width: unset;
        width:1;
      }
  }
.document-container{
    height: calc(100% - 6rem);
    display: flex;
    justify-content: space-around;
    .container{
        padding: 1rem;
        background: var(--documentListBackgroundColor);
        width: 600px;
        border-radius: 1rem 1rem 0rem 0rem;
        overflow: auto;
    }
    .withborder{
        border-radius: 1rem 1rem 1rem 1rem;
      }
    .documentcard{
      
      border-radius: 1rem;
      background-color: var(--documentInfoBackgroundColor);
      color: var(--documentInfoTextColor);
      padding: 0.5rem;
      margin: 0.5rem;
      word-break: break-word;
      cursor: pointer;
    }
    .big-icons{
      font-size: 50px;
    }
    @media(max-width:768px) {
    .big-icons{
      font-size: 30px;
    }
  }
}
.button-container{
    height:6rem;
    display: flex;
    justify-content: space-around;
    .btn {
        @include btn100percent;
        width: 300px;
        background-color: var(--documentUploadFileBackgroundColor);
        color: var(--documentUploadFileTextColor);
    }
    .container{
        padding: 1rem;
        background: var(--documentListBackgroundColor);
        width: 600px;
        border-radius: 0rem 0rem 1rem 1rem ; 
    }
    .progress-wrapper {
    width:100%;
}
.progress-wrapper .progress {
    background-color:green;
    width:0%;
    padding:5px 0px 5px 0px;
}
}


</style>